<template>
  <div>
    <el-form ref="bulkImportFormRef" :model="bulkImportForm" label-position="top" style="margin: 20px">
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <el-select v-model="bulkImportForm.numberType" class="select_type_class">
              <el-option label="运单号（Número de rastreio da Anjun）" :value="1" /><!--运单号-->
              <el-option label="扫描单号（Código de barra）" :value="2" /><!--扫描单号-->
            </el-select>
            <el-input
              v-model="numberBox"
              :placeholder="$t('collectionCenter.multiLineInputLimit')"
              :rows="3"
              type="textarea"
              style="width: 100%"
              @blur="BlockNewline"
              @keydown.enter.native="BlockNewline"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!--事件类型-->
          <el-form-item
            label="事件类型（Tipo de evento）" prop="eventType"
            :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
          >
            <el-select v-model="bulkImportForm.eventType" style="width: 100%" clearable>
              <el-option :label="$t('collectionCenter.discrepancyReport')" :value="1" /><!--差异上报-->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="描述（Descrição）" prop="description"
            :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
          >
            <el-input
              v-model="bulkImportForm.description"
              :rows="2"
              type="textarea"
              clearable
              style="width: 100%"
              show-word-limit
              maxlength="500"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="添加照片（Adicionar imagens）" class="select_picture_class"
          >
            <el-upload
              ref="uploadRef"
              v-model="photograph"
              class="avatar-uploader"
              :show-file-list="true"
              :file-list="imageList"
              :limit="5"
              :before-upload="beforeUpload"
              :on-exceed="handleExceed"
              :http-request="uploadDataClick"
              :on-remove="handleRemove"
              action="#"
              list-type="picture-card"
              multiple
            >
              <i class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
          </el-form-item>
          <div style="color: #606266; font-size: 13px">
            {{ $t('collectionCenter.uploadImageLimit5') }}
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align: right; margin: 20px">
      <el-button @click="bulkImportClose">{{ $t('GlobalSetObj.cancel') }}</el-button>
      <el-button type="primary" @click="bulkImportSubmit">{{ $t('GlobalSetObj.confirm') }}</el-button>
    </div>

    <el-dialog
      :title="$t('GlobalSetObj.ImportResults')"
      :visible.sync="resultDialogVisible"
      width="40%"
      :before-close="resultClose"
      append-to-body
    >
      <div>
        <div class="result_title_class">
          <span>{{ $t('collectionCenter.totalImported') }}{{ resultData.totalCount }}</span><!--总导入-->
          <span>{{ $t('orderCenterCont.ImportWasSuccessful') }}{{ resultData.successCount }}</span><!--导入成功-->
          <span>{{ $t('orderCenterCont.ImportFailed') }} <span style="color: #af3e40">{{ resultData.failCount }}</span></span><!--导入失败-->
        </div>
        <div v-if="resultData.failReasonList && resultData.failReasonList.length > 0">
          <div v-for="(item, index) in resultData.failReasonList" :key="index">
            {{ index + 1 }}. {{ item.waybillNumber }}，{{ item.reason }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resultClose">{{ $t('GlobalSetObj.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  handoverAbnormalityBatchImport
} from '@/api/newExpressAPI';
import { uploadOos } from '@/utils/ali_oos_util';
const PARAM = {
  numberType: 1, // 操作类型 1.运单号，2.扫描单号
  numberList: [], // 单号列表
  eventType: null, // 事件类型 1.差异上报
  description: '', // 描述
  ticketPictureList: [] // 图片(>3 && <5)
};
export default {
  data() {
    return {
      bulkImportForm: {
        ...PARAM
      },
      numberBox: '',
      fileList: [],
      imageList: [],
      resultDialogVisible: false,
      resultData: {},
      uploading: false, // 监控照片上传完成
      photograph: ''
    };
  },
  methods: {
    bulkImportOpen() {
      this.photograph = '';
      this.bulkImportForm = {
        ...PARAM
      };
      this.fileList = [];
      this.imageList = [];
      this.numberBox = '';
      this.uploading = false; // 重置上传状态
      this.$refs.bulkImportFormRef.clearValidate();
    },
    bulkImportClose() {
      this.bulkImportOpen();
      this.$emit('bIClose');
    },
    BlockNewline() {
      this.$nextTick(() => {
        if (this.numberBox) {
          let lines = this.numberBox.split('\n').filter(line => line.trim() !== '');
          if (lines.length > 50000) {
            lines = lines.slice(0, 50000);
            this.$message.warning(this.$t('collectionCenter.intercept50000'));
          }
          this.numberBox = lines.join('\n');
          this.bulkImportForm.numberList = lines;
        }
      });
    },
    handleExceed(file, fileList) {
      if (fileList.length >= 5) {
        this.$message.error(this.$t('collectionCenter.uploadImageLimit'));
        return;
      }
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      const whiteList = ['jpg', 'jpeg', 'png', 'gif'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 支持的图片格式
        this.$message.error(this.$t('GlobalSetObj.formatFile'));
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        // 上传文件大小不能超过 10MB
        this.$message.error(this.$t('collectionCenter.uploadNot10MB'));
        return false;
      }
    },
    // 删除
    handleRemove(file) {
      const uid = file.uid;
      if (file.uid) {
        const findIndex = this.fileList.findIndex((item) => item.uid === uid);
        if (findIndex !== -1) {
          this.fileList.splice(findIndex, 1);
        }
      }
      if (this.fileList.length === 0) {
        this.photograph = '';
      }
    },
    async uploadDataClick(option) {
      const files = option.file;
      this.uploading = true;
      try {
        const res = await uploadOos(files, 'service');
        if (res.code === 200) {
          this.photograph = res.url;
          if (this.fileList.length < 5) {
            this.fileList.push({
              url: res.url,
              uid: files.uid
            });
          }
        } else {
          // 上传图片失败
          this.$message.error(this.$t('fixDutyFine.imageUploadFailed'));
        }
      } catch (error) {
        this.$message.error(this.$t('fixDutyFine.imageUploadFailed'));
      } finally {
        this.uploading = false;
      }
    },
    bulkImportSubmit() {
      if (this.uploading) {
        this.$message.warning(this.$t('collectionCenter.waitForUploadImages'));
        return;
      }
      if (this.fileList.length < 3) {
        this.$message.warning(this.$t('collectionCenter.atLeastThreeImages'));
        return;
      }
      if (!this.numberBox) {
        this.$message.error(this.$t('collectionCenter.enterTrackingNumber'));
        return;
      }
      this.$refs.bulkImportFormRef.validate((valid) => {
        if (valid) {
          this.bulkImportForm.ticketPictureList = this.fileList.map(item => item.url);
          handoverAbnormalityBatchImport(this.bulkImportForm).then(res => {
            if (res.code === 200) {
              this.resultData = res.data;
              this.$emit('toSearch');
              this.resultDialogVisible = true;
            }
          });
        }
      });
    },
    resultClose() {
      this.resultDialogVisible = false;
      this.bulkImportClose();
    }
  }
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.avatar-uploader .el-upload:hover {
  border-color: #00A551;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.select_picture_class .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.select_picture_class .el-form-item__label {
  position: relative;
  margin-left: 10px;
  &::before{
    position: absolute;
    content: '*';
    color: #F56C6C;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.select_type_class {
  display: block;
  position: relative;
  margin-left: 10px;
  &::before{
    position: absolute;
    content: '*';
    color: #F56C6C;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.select_type_class .el-input .el-input__inner {
  color: #606266;
  font-size: 14px;
  font-weight: 700;
}
.result_title_class {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 20px;
}
</style>
